module.exports = __webpack_public_path__ + "static/media/674.666d9c52.webp";